import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class KpiQueryService {

    private CREATE_KPI_DETAILS: any;

    private GET_ALL_KPI:any;

    private UPDATE_KPI_DETAILS:any;

    constructor(public apollo: Apollo) {


        //Create KPI   detail
        this.CREATE_KPI_DETAILS = gql` 
            mutation createKpi($input:CreateKpiInput!){
                createKpi(input:$input){
                    kpi {
                        kpiDetails
                        createdAt
                      }
                    
                }
            }
       `;

        //Get KPI report  detail
        this.GET_ALL_KPI = gql` 
            query{
                allKpis {
                            nodes {
                                id
                                kpiDetails
                                createdAt
                            }
                    
                }
            }
       `;

        //Update KPI report  detail
        this.UPDATE_KPI_DETAILS = gql` 
            mutation UpdateKPI($input: UpdateKpiByIdInput!) {
                updateKpiById(input:$input){
                    kpi{
                        id
                    }
                }
            }
       `;

    }

    // Create KPI
    CREATE_KPI(allkpiDetails) {
        return this.apollo.mutate({
            mutation: this.CREATE_KPI_DETAILS,
            variables: {
                "input": {
                    "kpi": 
                    {
                        "kpiDetails":JSON.stringify(allkpiDetails.kpiDetails),
                        "createdAt": new Date()
                    }
                 }
              },
        })
    }

    //To Get all kpi details
    GET_ALL_KPI_DETAILS(): any{
        return this.apollo
            .watchQuery({
                query: this.GET_ALL_KPI,
                fetchPolicy: 'network-only'
            });
    }

    UPDATE_KPI_DETAILS_BY_ID(allkpiDetails,kpiId) {
        return this.apollo.mutate({
            mutation: this.UPDATE_KPI_DETAILS,
            variables: {

                "input": {
                    "id": kpiId,
                    "kpiPatch": {
                        "kpiDetails": JSON.stringify(allkpiDetails.kpiDetails),
                        "createdAt": new Date()
                     }
                }
            },
            fetchPolicy: 'no-cache'
        })
    }


}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/kpi.ts